import { useEffect } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";

export function AuthCallbackHandler({
  children,
}: {
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Let AuthCallbackPage handle callbacks at /auth/callback — it properly
    // waits for the auth state to settle before navigating.
    if (location.pathname === "/auth/callback") {
      return;
    }

    // Check if this is an auth callback
    const hashParams = new URLSearchParams(location.hash.substring(1));
    const queryParams = new URLSearchParams(location.search);

    const type = hashParams.get("type") || queryParams.get("type");
    const error = hashParams.get("error") || queryParams.get("error");
    const errorDescription =
      hashParams.get("error_description") ||
      queryParams.get("error_description");

    if (error) {
      toast.error(
        errorDescription || "Authentication failed. Please try again.",
        {
          duration: 5000,
        }
      );
      return;
    }

    // Handle different auth callback types
    if (type === "signup") {
      // Email confirmation successful
      navigate("/auth/confirm-email-success", { replace: true });
    } else if (type === "recovery") {
      // Password recovery link clicked
      navigate("/auth/update-password", { replace: true });
    } else if (type === "invite") {
      // User invitation accepted
      navigate("/auth/confirm-email-success", { replace: true });
    } else if (type === "email_change") {
      // Email change confirmed
      navigate("/auth/confirm-email-success", { replace: true });
    }
  }, [location, navigate]);

  return <>{children}</>;
}
